import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import RemindersForm from '../../components/Reminders/RemindersForm';
import {
  PERMISSION_REMINDERS,
  PERMISSION_REMINDERS_OWNED_BY_USER,
} from '../../Services/PermissionsService';
import { requirePermissions } from '../../router/RouteGuardsService';

// Optional params passed from the reminders list row actions
const editReminderSearchSchema = z.object({
  'customer-id': z.coerce.number().optional().catch(undefined),
  status: z.string().optional().catch(undefined),
  duplicate: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/reminders/edit/$id')({
  validateSearch: editReminderSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermissions(
      [PERMISSION_REMINDERS, PERMISSION_REMINDERS_OWNED_BY_USER],
      ['update'],
      '/unauthorized',
      context
    );
    return {
      ...context,
      documentTitle: { main: 'reminderForm.editTitle' },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EditReminderRoute,
});

// RemindersForm is self-contained (reads the edit id from the URL).
function EditReminderRoute() {
  return <RemindersForm />;
}
